import { core } from '../core/index.js';
import { filterFabricErrors } from '../errors/errors.js';
import { utils } from '../utils/index.js';

/**
 * 获取本机安装的app列表
 */
export type FabricGetInstalledAppsCallbackData = {
  /**
   * 安装的app列表
   */
  appList?: Array<{
    name: string;
  }>;
};

/**
 * 获取本机安装的app列表
 */
export type FabricUtilsGetInstalledAppsApi =
  () => Promise<FabricGetInstalledAppsCallbackData>;

/**
 * 获取本机安装的app列表, 仅仅安装支持, iOS无法获取.
 */
export const getInstalledApps: FabricUtilsGetInstalledAppsApi = () => {
  return new Promise<FabricGetInstalledAppsCallbackData>((resolve, reject) => {
    // IPhone设备没有applist权限, 不能获取.
    if (utils.webview.isIphone()) {
      resolve({ appList: [] });
    } else {
      core.call<
        'fabric_utils.getInstalledApps',
        null,
        FabricGetInstalledAppsCallbackData
      >('fabric_utils.getInstalledApps', null, (result) => {
        const fabricErrors = filterFabricErrors(
          result.code,
          result.message,
          result.data
        );
        if (fabricErrors) {
          reject(fabricErrors);
        } else {
          resolve(result.data);
        }
      });
    }
  });
};
